module.exports = __webpack_public_path__ + "static/media/flag.bed2a709.svg";